import { color } from '@utilitywarehouse/hearth-tokens/js';

import InnerContainer from '~/components/Layout/InnerContainer';
import SectionContainer from '~/components/Layout/SectionContainer';
import { useGetContentfulButtonTextBySlug } from '~/hooks/useContentful';

import FooterLegalAccordion from './Footer/FooterLegalAccordion';
import { useFooterLegalContent } from './Footer/useFooterLegalContent';

function Footer() {
  const { data: legalButtonText } =
    useGetContentfulButtonTextBySlug('legalButton');
  const legalContent = useFooterLegalContent();

  const legalButtonLabel = legalButtonText?.Fields?.text || 'The legal bit';

  return (
    <SectionContainer
      as="footer"
      backgroundColor={color.warmWhite[50]}
      paddingY="400"
      dataTestId="footer"
    >
      <InnerContainer>
        <FooterLegalAccordion
          question={legalButtonLabel}
          answer={legalContent}
        />
      </InnerContainer>
    </SectionContainer>
  );
}

export default Footer;
